<template>
  <div
    ref="itemRef"
    class="px-4 mx-0.5 bg-neutral-secondary rounded-full cursor-pointer"
  >
    <NumberFormatter #="{ number }" :value="numberSuggestion">
      <NText
        dir="ltr"
        variant="overline"
        weight="medium"
        class="text-neutral-secondary-hover"
        @click="$emit('suggestionNumber', itemRef, numberSuggestion)"
      >
        {{ number }}
      </NText>
    </NumberFormatter>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';

import NumberFormatter from '@/components/Number.vue';

type FlashTradingSuggestion = {
  numberSuggestion: number | undefined;
};

type SuggestionNumberEmits = {
  (
    e: 'suggestionNumber',
    value: HTMLElement,
    suggestion: number | undefined
  ): void;
};

defineEmits<SuggestionNumberEmits>();

defineProps<FlashTradingSuggestion>();

const itemRef = ref();
</script>
